export default () => {

  const link = document.getElementById('home-find-nearest');

  if (!link) {
    return;
  }

  const error = document.getElementById('home-find-error');
  const LOADING = 'loading';

  let fired = false;

  const handleError = () => {
    link.classList.remove(LOADING);
    link.classList.add('error');
    error.style.display = 'block';
  };

  const handleSuccess = (lat, lng) => {
    const searchResultPageUrl = link.href;
    window.location.assign(`${searchResultPageUrl}?lat=${lat}&lng=${lng}`);
  };

  const findLocation = () => {
    link.classList.add(LOADING);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        handleSuccess(lat, lng);
      }, () => {
        handleError();
      });
    } else {
      handleError();
    }
  };

  const handleClick = e => {
    e.preventDefault();
    if (fired) return;
    fired = true;
    findLocation();
  };
  link.addEventListener('click', handleClick);

}